import { AnalyticsBrowser } from "@segment/analytics-next";
import { cleanText, generateUniqueId } from ".";
import { handleAppError } from "./error-handler";

export const analytics = new AnalyticsBrowser();
const brandPage = "mangrove";
const urlParams = Object.fromEntries(
  new URLSearchParams(window.location.search)
);

const getIPDetails = async (ip) => {
  try {
    const response = await fetch(
      `https://ipinfo.io/${ip}/json?token=${process.env.REACT_APP_IPINFO_TOKEN}`
    );
    return response.json();
  } catch (error) {
    return {};
  }
};

export const initializeSegment = async () => {
  try {
    let userId = localStorage.getItem("ajs_user_id");
    analytics.load({ writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY });
    const ipResponse = await fetch("https://api64.ipify.org?format=json");
    const { ip } = await ipResponse.json();
    const ipDetails = await getIPDetails(ip);
    if (userId && userId.length > 8) return; // if there is a user initialized, return ::: this is to prevent multiple initializations
    if (!userId || userId === "null") {
      userId = generateUniqueId();
      localStorage.setItem("ajs_user_id", userId);
    }
    identifyUser(userId, {
      timestamp: new Date().toLocaleString(),
      device: window.navigator.userAgent,
      ...ipDetails,
      brandPage,
      ...urlParams,
    });
  } catch (error) {
    handleAppError();
  }
};

let trackEventRunCount = 0;
export const trackEvent = (event, properties) => {
  trackEventRunCount++;
  if (
    analytics &&
    localStorage.getItem("ajs_user_id") !== "null" &&
    localStorage.getItem("ajs_user_id") !== null
  ) {
    let userId = localStorage.getItem("ajs_user_id");
    let userTraits = JSON.parse(localStorage.getItem("ajs_user_traits"));
    analytics.track(event, {
      ...properties,
      userId: cleanText(userId),
      ...userTraits,
      brandPage,
      ...urlParams,
    });
  } else {
    console.error("Segment not initialized");
    if (trackEventRunCount < 3) {
      return new Promise(async (resolve, reject) => {
        try {
          await initializeSegment();
          resolve(trackEvent(event, properties));
        } catch (error) {
          reject(error);
        }
      });
    }
  }
};

export const identifyUser = (userId, traits) => {
  if (analytics) {
    analytics.identify(cleanText(userId), traits);
  } else {
    console.error("Segment not initialized");
  }
};

let trackPageRunCount = 0;

export const trackPageView = (page, properties = {}) => {
  trackPageRunCount++;
  if (
    analytics &&
    localStorage.getItem("ajs_user_id") !== "null" &&
    localStorage.getItem("ajs_user_id") !== null
  ) {
    let userId = localStorage.getItem("ajs_user_id");
    let userTraits = JSON.parse(localStorage.getItem("ajs_user_traits"));
    analytics.page(page, {
      ...properties,
      userId: cleanText(userId),
      ...userTraits,
      brandPage,
      ...urlParams,
    });
  } else {
    console.error("Segment not initialized");
    if (trackPageRunCount < 3) {
      return new Promise(async (resolve, reject) => {
        try {
          await initializeSegment();
          resolve(trackPageView(page, properties));
        } catch (error) {
          reject(error);
        }
      });
    }
  }
};

export default analytics;
